import { render, staticRenderFns } from "./NavMenuSidebar.vue.js?vue&type=template&id=2db34827&scoped=true!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NavMenuSidebar.vue?vue&type=template&id=2db34827&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db34827",
  null
  
)

export default component.exports